import { z } from 'zod'
import { revisionSchema, text } from '../validators'
import { SAVED_VIEW_SCOPES } from '../vocab'
import { reportFiltersSchema } from './filters'

/** Saved views are private to their owner (PORT-009) and capped per owner (PORT-008). */
export const SAVED_VIEW_LIMIT = 30

export const savedViewCreateSchema = z.strictObject({
  name: text(2, 80),
  scope: z.enum(SAVED_VIEW_SCOPES.values).default('portfolio'),
  filters: reportFiltersSchema,
})
export type SavedViewCreate = z.infer<typeof savedViewCreateSchema>

export const savedViewUpdateSchema = z
  .strictObject({
    revision: revisionSchema,
    name: text(2, 80).optional(),
    filters: reportFiltersSchema.optional(),
  })
  .refine((v) => v.name !== undefined || v.filters !== undefined, {
    message: 'Change the name or the filters.',
  })
export type SavedViewUpdate = z.infer<typeof savedViewUpdateSchema>

export const savedViewDeleteSchema = z.strictObject({ revision: revisionSchema })

export const savedViewSchema = z.object({
  id: z.string(),
  name: z.string(),
  scope: z.enum(SAVED_VIEW_SCOPES.values),
  filters: z.record(z.string(), z.string()),
  revision: z.number().int(),
  created_at: z.string(),
  updated_at: z.string(),
})
export type SavedView = z.infer<typeof savedViewSchema>
